import { useState, useEffect } from 'react';
import Appconfig from '../config';
import whitelabelConfig, { type WhitelabelConfigType } from '../whitelableConfig';

interface IUseSubdomain {
  subdomain: string | null;
  isMainAppSubDomain: boolean;
  config: WhitelabelConfigType;
}

export function getWhitelableConfig(host: string): WhitelabelConfigType | null {
  if (!host) return null;

  if (whitelabelConfig[host]) return whitelabelConfig[host];

  const suffixMatch = Object.keys(whitelabelConfig).find(
    (key) => host === key || host.endsWith(key),
  );
  if (suffixMatch) return whitelabelConfig[suffixMatch];

  return null;
}

const configTemplate = {
  name: '',
  logoUrl: '',
  socialMediaLinks: {},
  footerTilte: '',
  footerLinks: [],
  embedUrls: [],
};

function useSubdomain(): IUseSubdomain {
  const [data, setData] = useState<IUseSubdomain>({
    subdomain: Appconfig.appSubDomain,
    isMainAppSubDomain: true,
    config: configTemplate,
  });

  useEffect(() => {
    let hostname = (typeof window !== 'undefined' ? window.location.hostname : '')
      .replace(/^https?:\/\//, '') // remove http:// or https://
      .split('/')[0] // remove path
      .split(':')[0]; // remove port

    if (hostname.includes('localhost')) {
      hostname = Appconfig.appSubDomain;
    }
    const subdomain = hostname;
    const isMainAppSubDomain = subdomain === Appconfig.appSubDomain;
    const config = getWhitelableConfig(subdomain) || configTemplate;
    setData({ subdomain, isMainAppSubDomain, config });
  }, []);

  return data;
}

export default useSubdomain;
